
import { withStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';
import MuiCollapse from '@mui/material/Collapse';
import { TransitionProps } from '@mui/material/transitions';

interface IProps {
  open: boolean;
  children: React.ReactNode;
  mountOnEnter?: boolean;
  unmountOnExit?: boolean;
  onEntered?: (node: HTMLElement, isAppearing: boolean) => void;
  onEntering?: (node: HTMLElement, isAppearing: boolean) => void;
  onExited?: (node: HTMLElement) => void;
  // Collapse has a faulty implementation. keyof HTMLElementTagNameMap shouldn't be needed.
  // Recheck when new material versions are released
  component?: React.ElementType<TransitionProps>;
  timeout?: TransitionProps['timeout'] | 'auto';
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
  className?: string;
}

const styles = (theme: Theme) => ({
  /** MUI Classes */
  /** Styles applied to the outer wrapper element. */
  wrapper: {},
  /** Styles applied to the inner wrapper element. */
  wrapperInner: {},
});

/**
 * Utfällbar yta som gömmer innehåll. Används typiskt i implementationen av en BaseComponent/Component och inte direkt i vyer.
 */
export const EDCollapse = (props: IProps) => {
  const { open, children, ...rest } = props;

  return (
    <MuiCollapse in={open} {...rest}>
      {children}
    </MuiCollapse>
  );
};

export default withStyles(EDCollapse, styles);
